import { combineReducers } from "redux";

import { BeautyProfileReducer } from "state/reducers/user/BeautyProfileReducer";
import { EditionsReducer } from "state/reducers/user/EditionsReducer";
import { NotifsReducer } from "state/reducers/user/NotifsReducer";
import { PartnerGeneralReducer } from "state/reducers/user/PartnerGeneralReducer";
import { PartnerInfoReducer } from "state/reducers/user/PartnerInfoReducer";
import { PartnerSalesReducer } from "state/reducers/user/PartnerSalesReducer";
import { PersonReducer } from "state/reducers/user/PersonReducer";
import { RewardsReducer } from "state/reducers/user/RewardsReducer";
import { SubscribersReducer } from "state/reducers/user/SubscribersReducer";
import { TokenReducer } from "state/reducers/user/TokenReducer";
import { UiReducer } from "state/reducers/UiReducer";
import { StateReducer } from "state/reducers/StateReducer";
import { PaymentReducer } from "state/reducers/user/PaymentReducer";
import { CreditCardReducer } from "./reducers/user/CreditCardReducer";
import { InstagramInfoReducer } from "./reducers/user/InstagramInfoReducer";
import Modals from "state/ducks/Modals";
import { FileReducer } from "./reducers/user/FileReducer";
import PartnerCreate from "state/ducks/PartnerPath";
import { PartnerResultsReducer } from "./reducers/user/PartnerResultsReducer";

export const Reducers = combineReducers({
  state: StateReducer, 

  token: TokenReducer,
  person: PersonReducer,
  subscribers: SubscribersReducer,
  editions: EditionsReducer,
  notifs: NotifsReducer,
  partnerInfo: PartnerInfoReducer,
  partnerGeneral: PartnerGeneralReducer,
  partnerSales: PartnerSalesReducer,
  rewards: RewardsReducer,
  beautyProfile: BeautyProfileReducer,
  payment: PaymentReducer,
  creditCardInfo: CreditCardReducer,
  ui: UiReducer,
  instagramInfo: InstagramInfoReducer,
  modals: Modals,
  file: FileReducer,
  partnerResults: PartnerResultsReducer,
  partnerCreate: PartnerCreate
});
